import {MenuContext, MenuProvider} from './menu-context';

export {MenuContext, MenuProvider};

export default MenuContext;
